<ppl-accordion [title]="'Forms'" [isOpen]="true" *authorize="[pageId, tabId, 'Forms', 'section']">
    @if(isPA) {
    <p class="pt-2" id="pa-note-content" role="text"><strong>Note:</strong> To access the payment method form, call PPL
        at 1-833-247-5346 or download it from our website at <a aria-labelledby="pa-note-content"
            href="https://pplfirst.com/wp-content/uploads/2025/07/Payment-Method-Form.pdf"
            target="_blank">https://pplfirst.com/wp-content/uploads/2025/07/Payment-Method-Form.pdf</a>. Note that any
        requests for electronic payment (non-paper checks) must be submitted through the payment method form. For your
        security, PPL will contact you to verify you submitted the form. </p>
    }

    <ppl-pdf-form [readonly]="mode" [isNewReferral]="isNewReferral" [pageId]="pageId" [tabId]="tabId"
        (isMandatoryFormsCompleted)="isMandatoryFormsCompleted($event)"></ppl-pdf-form>
</ppl-accordion>

@if(!isNewReferral && !isMobile){
<ppl-accordion [title]="'Mail Summary'" [isOpen]="true">
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [data]="mailFormsData" [disableSelection]="true"
        [cols]="cols" [gridTitle]="false" [pagination]="false" [loadPage]="true">
    </ppl-list-table>
</ppl-accordion>
}